import React from 'react'
import PropTypes from 'prop-types'
import PerformanceItem from '../PerformanceItem'

function VarianceModal() {
	return (
		<div className='performance_item_modal variance_modal'>
			<h3>Variance</h3>
			<p>
				For most campaigns, it&apos;s ideal to keep ad spend variance within 10%. Keeping your spend consistent across the flight enables Facebook to optimize your bids.
			</p>
			<p>
				Bonus points if you implement a pacing dashboard that&apos;s real-time and easy to read. This helps campaign managers track pacing and performance on multiple levels.
			</p>
		</div>
	)
}

const renderVarianceBody = (value, benchmark) => {
	
	if(value===null) {
		return (
			<p>We could not calculate your spend variance as you haven&apos;t spent anything for the past 30 days.</p>
		)
	}
	let varianceStr = value.toLocaleString('en', {style: 'percent'})
	const formatPercent = (num) => { return num.toLocaleString('en', {style: 'percent'}) }
	if(value <= benchmark.us) {
		return (
			<p>You have kept your spend variance within {varianceStr}. Great job!</p>
		)
	} else {
		return (
			<p>Your daily ad spend varies by {varianceStr}, when you should keep it within {formatPercent(benchmark.us)} to maximize performance.</p>
		)
	}
}

function VariancePerformanceItem(props) {
	// "variance":{"score":12,"maxScore":12,"value":0.04294987712709239,"benchmark":0.12}
	const { score, maxScore, value, benchmark } = props.apiScore
	return (
		<PerformanceItem
			title="Variance"
			score={score}
			maxScore={maxScore}
			showPerformanceModal={() => { props.showPerformanceModal('variance') }}>
			{renderVarianceBody(value, benchmark)}
		</PerformanceItem>
	)
}
VariancePerformanceItem.propTypes = {
	apiScore: PropTypes.object,
	showPerformanceModal: PropTypes.func
}

export { VarianceModal, VariancePerformanceItem }


// WEBPACK FOOTER //
// ./src/containers/ReportLoaderTopLeads/components/performance_items/Variance.js